var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count)?_c('div',{staticClass:"counter-badge",class:{ changed: _vm.changed }},[_vm._v("\n  "+_vm._s(_vm.count > 99 ? '99+' : _vm.count)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }